import { render, staticRenderFns } from "./ModalCreateYieldSetting.vue?vue&type=template&id=70cbfef2&scoped=true"
import script from "./ModalCreateYieldSetting.vue?vue&type=script&lang=js"
export * from "./ModalCreateYieldSetting.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateYieldSetting.vue?vue&type=style&index=0&id=70cbfef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cbfef2",
  null
  
)

export default component.exports